import type { FaireProductEntity } from "../../entity_types/product";

export const p_jrv5q5s8zu: FaireProductEntity = {
  token: "p_jrv5q5s8zu",
  type: "product",
  name: 'Natural Woven Rope Doormat-24x48" L',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/4deefcc78f2d73aad3d9c457154c680e602d30db111abce7551ff24fdfa6815c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/26424691370822858ef52a601305d598976200f2a10ac2c7c75dafe4fb2ed599.jpeg",
  ],
  priceDollars: 55,
  description:
    "Give your entranceway some rustic, handsomely crafted charm with this Extra Large Natural Woven Rope Doormat. Crafted out of durable coir fiber to withstand even the harshest weather, this natural-colored doormat features an intricately woven pattern created with thick strands of coir fiber to make your doorway more artful and inviting. Other doormats are also available.",
  tags: [],
  msrpDollars: 110,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:17.684Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
